import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import AppBrandingProvider from './config/AppBrandingProvider';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
serviceWorkerRegistration.unregister();

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <BrowserRouter>
    <AppBrandingProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </AppBrandingProvider>
  </BrowserRouter>
);
